exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".note-container { font-size: 1.2em; }\n\t\n.note-author, .note-time {\n  font-weight: bold;\n  color: #3131b9;\n}\n\n.note-text {\n  display: block;\n  padding: 3px 0 5px;\n  margin: 5px 0;\n  border-bottom: 1px solid #e8e8e8;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/notes-history/notes-history.css
// module id = ../../../../../angular/app/components/defaults/notes-history/notes-history.css
// module chunks = 1